export default [
  {
    title: 'Name',
    dataIndex: 'name',
    render: () => 'Classroom'
  },
  {
    title: 'Branch',
    dataIndex: 'branch'
  }
];
